import { useWidgetPageDeleteApi } from '@/common/api/modules/widgetPage'
import { widgetPageEditPath } from '@/common/app/path'
import { WidgetPage } from '@/common/model/recommend/widgetPage'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  widgetPage: WidgetPage
  onRefresh: () => void
}

const WidgetPageListRow = ({ widgetPage, onRefresh }: Props) => {
  const { onClickDelete } = useWidgetPageDeleteApi(widgetPage, onRefresh)
  const editPath = widgetPageEditPath(widgetPage.site_id, widgetPage.id)

  return (
    <ClickableTableRow href={editPath}>
      <TableRowItem width={320}>
        <TextButton link={editPath} bold>
          {widgetPage.name}
        </TextButton>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{widgetPage.target_url ?? '-'}</Text>
      </TableRowItem>
      <TableRowItem width={64}>
        <Button color={ButtonColor.SECONDARY} size='icon' square onClick={onClickDelete}>
          <Icon type={IconType.TRASH} color={IconColor.CRITICAL} />
        </Button>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default WidgetPageListRow
